// react
import React, { useEffect, useState } from "react";

// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showAppModal } from "~/redux/actions/app";
import { unMuteUser } from "~/redux/actions/user";

// antd
import { Button } from "antd";

// utils
import { hasAnyRole } from "~/utils/user";
import moment from "moment";
import _ from "lodash";

const UserMuteBlock = (props) => {
  const { user, token } = props;

  const isAdmin = hasAnyRole(props.currentUser, ["admin"]);

  const releaseOn = _.get(user, "release_on");
  // const isMuted = releaseOn && moment(releaseOn).isAfter()

  const [isMuted, setIsMuted] = useState(
    releaseOn && moment(releaseOn).isAfter()
  );

  const handleMuteUser = () => {
    props.showAppModal("MuteUserModal");
  };

  const handleBanUser = () => {
    props.showAppModal("BanUserModal");
  };

  const handleUnmuteUser = () => {
    if (user) {
      props.unMuteUser(token, user.id, () => {
        setIsMuted(false);
      });
    }
  };

  const muteButton = (
    <Button
      style={{ padding: "2px 4px" }}
      type="link"
      onClick={() => {
        handleMuteUser();
      }}
    >
      禁言
    </Button>
  );

  const unMuteButton = (
    <Button
      style={{ padding: "2px 4px" }}
      type="link"
      onClick={() => {
        handleUnmuteUser();
      }}
    >
      取消禁言
    </Button>
  );

  return (
    <div>
      {isAdmin && (isMuted ? unMuteButton : muteButton)}
      {isAdmin && (
        <Button
          style={{ padding: "2px 4px" }}
          type="link"
          onClick={() => {
            handleBanUser();
          }}
        >
          封禁
        </Button>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
      unMuteUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserMuteBlock);
